// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomSelect {
    position: relative;
    display: inline-block;
}

.CustomSelect_trigger {
    background: #FFFFFF;
    border: 1px solid #E0E4E7;
    border-radius: 8px;
    padding: 8px 16px;
    font-size: calc(14px * var(--fontScaler));
    color: #000000;
    cursor: pointer;
    outline: none;
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 150px;
    user-select: none;
    position: relative;
}

.CustomSelect_trigger:hover {
    background-color: #F9F9F9;
}

.CustomSelect_trigger--open {
    border-color: #FFA825;
    box-shadow: 0 0 0 2px rgba(255, 168, 37, 0.2);
}

.CustomSelect_value {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 24px;
}

.CustomSelect_arrow {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    transition: transform 0.2s;
    pointer-events: none;
}

.CustomSelect_trigger--open .CustomSelect_arrow {
    transform: translateY(-50%) rotate(180deg);
}

.CustomSelect_dropdown {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    background: #FFFFFF;
    border: 1px solid #E0E4E7;
    border-radius: 8px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    max-height: 250px;
    overflow-y: auto;
    z-index: 1000;
}

.CustomSelect_option {
    padding: 10px 16px;
    font-size: calc(14px * var(--fontScaler));
    color: #000000;
    cursor: pointer;
    user-select: none;
}

.CustomSelect_option:first-child {
    border-radius: 8px 8px 0 0;
}

.CustomSelect_option:last-child {
    border-radius: 0 0 8px 8px;
}

.CustomSelect_option:only-child {
    border-radius: 8px;
}

.CustomSelect_option:hover {
    background-color: #F9F9F9;
}

.CustomSelect_option--selected {
    background-color: #3B82F6;
    color: #FFFFFF;
}

.CustomSelect_option--selected:hover {
    background-color: #2563EB;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/tasks/CustomSelect.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,yCAAyC;IACzC,cAAc;IACd,eAAe;IACf,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,OAAO;IACP,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,4CAA4C;IAC5C,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,yCAAyC;IACzC,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".CustomSelect {\n    position: relative;\n    display: inline-block;\n}\n\n.CustomSelect_trigger {\n    background: #FFFFFF;\n    border: 1px solid #E0E4E7;\n    border-radius: 8px;\n    padding: 8px 16px;\n    font-size: calc(14px * var(--fontScaler));\n    color: #000000;\n    cursor: pointer;\n    outline: none;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    min-width: 150px;\n    user-select: none;\n    position: relative;\n}\n\n.CustomSelect_trigger:hover {\n    background-color: #F9F9F9;\n}\n\n.CustomSelect_trigger--open {\n    border-color: #FFA825;\n    box-shadow: 0 0 0 2px rgba(255, 168, 37, 0.2);\n}\n\n.CustomSelect_value {\n    flex: 1;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    padding-right: 24px;\n}\n\n.CustomSelect_arrow {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    transition: transform 0.2s;\n    pointer-events: none;\n}\n\n.CustomSelect_trigger--open .CustomSelect_arrow {\n    transform: translateY(-50%) rotate(180deg);\n}\n\n.CustomSelect_dropdown {\n    position: absolute;\n    top: calc(100% + 4px);\n    left: 0;\n    right: 0;\n    background: #FFFFFF;\n    border: 1px solid #E0E4E7;\n    border-radius: 8px;\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);\n    max-height: 250px;\n    overflow-y: auto;\n    z-index: 1000;\n}\n\n.CustomSelect_option {\n    padding: 10px 16px;\n    font-size: calc(14px * var(--fontScaler));\n    color: #000000;\n    cursor: pointer;\n    user-select: none;\n}\n\n.CustomSelect_option:first-child {\n    border-radius: 8px 8px 0 0;\n}\n\n.CustomSelect_option:last-child {\n    border-radius: 0 0 8px 8px;\n}\n\n.CustomSelect_option:only-child {\n    border-radius: 8px;\n}\n\n.CustomSelect_option:hover {\n    background-color: #F9F9F9;\n}\n\n.CustomSelect_option--selected {\n    background-color: #3B82F6;\n    color: #FFFFFF;\n}\n\n.CustomSelect_option--selected:hover {\n    background-color: #2563EB;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
